import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "bg"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "logo"
})], -1);
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "login-form"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, " 保修业务管理系统", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_row = _resolveComponent("el-row");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 14
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 10
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createVNode(_component_el_form, {
        ref: "loginForm",
        model: _ctx.userinfo,
        rules: _ctx.loginRules,
        "hide-required-asterisk": true,
        size: "large"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "账号",
          prop: "username"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.userinfo.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.userinfo.username = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "密码",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _ctx.userinfo.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.userinfo.password = $event),
            type: "password",
            autocomplete: "off",
            "show-password": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            class: "login-btn",
            onClick: $setup.loginBtnHandle
          }, {
            default: _withCtx(() => [_createTextVNode("登录")]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])])])]),
      _: 1
    })]),
    _: 1
  })]);
}